<template>
	<v-list two-line width="100%">
		<template v-for="(salon, index) in salons">
			<v-list-item :href="salon.urlFrendlyLink" :key="salon.siteName">
				<v-list-item-icon class="mr-4">
					<v-img :src="salon.imageUrl" height="70" width="90"></v-img>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>{{ salon.siteName }}</v-list-item-title>
					<v-list-item-subtitle>
						<v-row align="center" justify="center">
							<v-col>
								<div class="small-text mb-2">{{ salon.getShortAddress }}</div>
								<span :class="salon.getIsOpenNow ? 'text--primary' : ''">{{ salon.getIsOpenNow ? 'Åpen nå' : 'Stengt' }}</span> -
								<span>{{ salon.getIsOpenNow ? 'Stenger kl. ' + salon.getTodaysOpeningHours.to : 'Åpner kl. ' + salon.getTodaysOpeningHours.from }}</span>
							</v-col>
						</v-row>
					</v-list-item-subtitle>
				</v-list-item-content>

				<v-list-item-icon>
					<v-row align="center" justify="center">
						<v-col>
							<v-icon color="primary">keyboard_arrow_right</v-icon>
						</v-col>
					</v-row>
				</v-list-item-icon>
			</v-list-item>
			<v-divider v-if="salons.length != index + 1" :key="index"></v-divider>
		</template>
	</v-list>
</template>

<script>
export default {
	props: ['module', 'salons']
};
</script>

<style></style>
